import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Container, Row, Col } from 'react-grid-system';
import { connect } from "react-redux";
import setCoverPresent, { setLightNav } from './redux/actions';
import './App.css';

const BG = '#085C34';

const row1Images = [
  { src: 'img/art-direction/figma-practice-MariaChimishkyan-1.jpg', caption: 'Figma', title: 'Practice' },
  { src: 'img/art-direction/figma-practice-MariaChimishkyan-2.jpg', caption: 'Figma', title: 'Practice' },
  // add more images here
];

const row2Images = [
  { src: 'img/art-direction/figma-prompt-MariaChimishkyan-1.jpg', caption: 'Figma', title: 'Practice' },
  // add more images here
];

function Slideshow({ images }) {
  const [idx, setIdx] = useState(0);
  const current = images[idx];

  return (
    <div>
      <img src={current.src} alt="" style={{ display: 'block', width: '100%' }} />
      {images.length > 1 && (
        <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
          {images.map((_, i) => (
            <span
              key={i}
              onClick={() => setIdx(i)}
              style={{
                fontFamily: 'Arial, Helvetica',
                fontSize: 13,
                color: '#fff',
                opacity: i === idx ? 1 : 0.3,
                cursor: 'pointer',
                userSelect: 'none',
              }}
            >
              {i + 1}
            </span>
          ))}
        </div>
      )}
      <div className="caption" style={{ marginTop: images.length > 1 ? 4 : 0 }}>{current.caption}</div>
      <div className="title">{current.title}</div>
    </div>
  );
}

function Commissions({ dispatch }) {
  useLayoutEffect(() => {
    const app = document.querySelector('.App');
    document.documentElement.style.backgroundColor = BG;
    document.body.style.backgroundColor = BG;
    if (app) app.style.backgroundColor = BG;
    return () => {
      document.documentElement.style.backgroundColor = '';
      document.body.style.backgroundColor = '';
      if (app) app.style.backgroundColor = '';
    };
  }, []);

  useEffect(() => {
    dispatch(setCoverPresent('no'));
    dispatch(setLightNav(BG));
    return () => dispatch(setLightNav(false));
  }, []);

  return (
    <div className="wrapper" style={{ backgroundColor: BG, minHeight: '100vh' }}>
      <div className="inner-wrapper">
        <Container fluid className="page-pad">

          {/* Top: two independent slideshows */}
          <Row style={{ marginBottom: 160 }}>
            <Col sm={3} />
            <Col sm={6}>
              <Slideshow images={row1Images} />
            </Col>
            <Col sm={3} />
          </Row>

          <Row style={{ marginBottom: 160 }}>
            <Col sm={3} />
            <Col sm={6}>
              <Slideshow images={row2Images} />
            </Col>
            <Col sm={3} />
          </Row>

          {/* Row: small left + video middle + small right */}
          <Row style={{ marginBottom: 160 }}>
            <Col sm={3}>
              <img src="img/art-direction/figma-VersionControl-AntonioCarrau.png" alt="" style={{ display: 'block', width: '100%' }} />
              <div className="caption">Figma</div>
              <div className="title">Version Control</div>
            </Col>
            <Col sm={3}>
              <img src="img/art-direction/figma-SoftwareIsCultureSwag-MaxGuther-Clothesline.jpg" alt="" style={{ display: 'block', width: '100%' }} />
              <div className="caption">Figma</div>
              <div className="title">Software is Culture Swag</div>
            </Col>
            <Col sm={6}>
              <video src="img/art-direction/figma-JuliaSchimautz-FigmaPatternLibrary.mp4" autoPlay muted loop playsInline style={{ display: 'block', width: '100%' }} />
              <div className="caption">Figma</div>
              <div className="title">Pattern Library</div>
            </Col>
          </Row>

          {/* Row: wide left */}
          <Row style={{ marginBottom: 160 }}>
            <Col sm={6}>
              <img src="img/art-direction/figma-ThomasColligan-FigmaforZines.png" alt="" style={{ display: 'block', width: '100%' }} />
              <div className="caption">Figma</div>
              <div className="title">Figma for Zines</div>
            </Col>
          </Row>

        </Container>
      </div>
    </div>
  );
}

export default connect()(Commissions);
